interface EmojiWrapperProps {
  emoji?: string;
}

export const EmojiWrapper = ({ emoji }: EmojiWrapperProps) => {
  if (!emoji) return null;

  const emojiUrl = `https://cdn.jsdelivr.net/npm/emoji-datasource-google/img/google/64/${emoji.toLowerCase()}.png`;

  return (
    <img
      src={emojiUrl}
      className='w-[35px] h-[35px] sm:w-[54px] sm:h-[54px]'
      draggable='false'
      alt='alert-emoji'
    />
  );
};
